import { OneTimePaymentRequestContract } from "./Contracts/OneTimePaymentRequestContract";
import { OneTimePaymentResponseContract } from "./Contracts/OneTimePaymentResponseContract";

declare global
{
	interface Window
	{
		NauUtility: any;
	}
}

const NauUtility = window.NauUtility;

/** Bill Pay Form creation and submission. */
export class BillPayForm
{
	/** Initialize form for making online payments. */
	public Initialize()
	{
		let paymentRequestFormData: OneTimePaymentRequestContract = {
			statementID: '',
			accountID: '',
			amountDue: ''
		}

		const formContainer = $("#billPaymentFormId").dxForm({
			showRequiredMark: false,
			showColonAfterLabel: true,
			labelLocation: "top",
			formData: paymentRequestFormData,
			onEditorEnterKey: () =>
			{
				this.SubmitForm(formContainer, paymentRequestFormData);
			},
			items: [
				{
					dataField: 'statementID',
					editorType: "dxTextBox",
					isRequired: true,
					label: {
						visible: true,
						text: "Statement #"
					},
					validationRules: [
						{
							type: "numeric"
						}, {
							type: "required"
						}
					]
				},
				{
					dataField: 'accountID',
					editorType: "dxTextBox",
					isRequired: true,
					label: {
						visible: true,
						text: "Account #"
					},
					validationRules: [
						{
							type: "numeric"
						}, {
							type: "required"
						}
					]
				},
				{
					dataField: 'amountDue',
					editorType: "dxNumberBox",
					helpText: 'Enter minimum due (excluding the $ sign) shown on your statement.  You can change your payment amount on the next screen.',
					isRequired: true,
					label: {
						visible: true,
						text: "Minimum Due"
					},
					editorOptions: {
						format: '#,##0.##',
					},
					validationRules: [
						{
							type: "required"
						}
					] 
				}
			]
		})

		$("#submitButton").dxButton({
			text: 'Submit',
			type: 'default',
			width: 150,
			useSubmitBehavior: false,
			onClick: () =>
			{
				this.SubmitForm(formContainer, paymentRequestFormData);
			}
		})
	}

	public SubmitForm(formContainer: JQuery<HTMLElement>, paymentRequestFormData: OneTimePaymentRequestContract) 
	{
		// submit request contract to be processed by our web application.
		const formInstance = formContainer.dxForm('instance');
		const result = formInstance.validate()
		
		if (result.isValid)
		{
			NauUtility.apiOps.postAsync({
				loadingMessage: 'Searching for Statement',
				apiVersion: '1.0',
				api: "/webapi/Financial/Billpay/paymentrequest",
				data: JSON.stringify(paymentRequestFormData),
				success: (response: OneTimePaymentResponseContract) =>
				{
					if (!response.isBillPayOpen)
					{
						// This should never trigger as the page would fail to load but in case it is turned off while someone has a the window open somewhere this will safe guard us.
						window.location.href = '/financial/billpay/closed'
					}

					if (response.encodedPartnerData == '' || response.externalRedirectUrl == '')
					{
						$("#unableToFindAccountErrorId").show()
						return
					}

					$("#unableToFindAccountErrorId").hide()

					// It is intentional to not have the # to look these up by name
					$('input[name="SAMLResponse"]').val(response.encodedPartnerData)
					$('form[name="SubmitPaymentRequest"]').attr('action', response.externalRedirectUrl)

					$('form[name="SubmitPaymentRequest"]').trigger("submit");
				},
				error: () =>
				{
					$("#unableToFindAccountErrorId").show()
				}

			});
		}
		else
		{
			$("#unableToFindAccountErrorId").show()
		}
	}
}
	